module.exports = {
  SOCIAL_LINKS: [
    { name: "Facebook", href: "https://www.facebook.com/bigmediaua" },
    { name: "Instagram", href: "https://www.instagram.com/bigmedia.ua/" },
    {
      name: "YouTube",
      href: "https://www.youtube.com/channel/UCyAy79L9mqFmMcoLOe4mV-g",
    },
    { name: "LinkedIn", href: "https://www.linkedin.com/company/bigmediaua" },
  ],
}
